import { websiteBaseURLs } from './url-config';

export const getPrivacyPolicyLink = (locale: string, navigateToFeedbackSection?: boolean) => {
  let privacyLink = '';
  const baseURL = websiteBaseURLs[locale] || websiteBaseURLs['en-us'];
  privacyLink = `${baseURL}/vista-privacy-and-cookie-notice`;
  if (navigateToFeedbackSection) {
    privacyLink = `${privacyLink}#what-personal-information`;
  }
  return privacyLink;
};
